/* Module1.store.js */

import axios from 'axios';
import iliosState from '@/ilios.store';

const initialState = () => ({
  apiState: iliosState.INIT,
  companyLogo: false,
  companyPhone: '--',
  companyWhatsApp: '--',
  companyEmail: '--',
  companyStreet: '--',
  companyZip: '--',
  companyNumber: '--',
  companyDistrict: '--',
  companyCity: '--',
  companyState: '--',
  companyContactEmail: '--',
  companyName: '--',
  companyYoutube: '',
  companyInstagram: '',
  companyFacebook: '',
  mainMenuColor: '',
  secondaryMenuColor: '',
  searchColor: '',
});

// State object
const state = {
  apiState: iliosState.INIT,
  companyLogo: null,
  companyPhone: '--',
  companyWhatsApp: '--',
  companyEmail: '--',
  companyStreet: '--',
  companyZip: '--',
  companyNumber: '--',
  companyDistrict: '--',
  companyCity: '--',
  companyState: '--',
  companyContactEmail: '--',
  companyName: '--',
  companyYoutube: '',
  companyInstagram: '',
  companyFacebook: '',
  mainMenuColor: '',
  secondaryMenuColor: '',
  searchColor: '',
}

// Getter functions
const getters = {

  getApiState() {
    return state.apiState
  },

  getcompanyEmail() {
    return state.companyEmail
  },

  getcompanyPhone() {
    return state.companyPhone
  }

};

// Actions
const actions = {

  setCompanyDetails(context) {
    var result = null
    context.commit('SET_API_STATE', {
      apiState: iliosState.LOADING
    });
    axios.post(process.env.VUE_APP_BASE_URL + '/web/portal_lar/get_info_company',
    {
      params: {
        payload: '{"token": "%token"}'.replace("%token", process.env.VUE_APP_TOKEN),
        context : {
          "lang": "pt_BR",
          "tz" : Intl.DateTimeFormat().resolvedOptions().timeZone
        },
      },
      headers: {
       'Content-Type' : 'form/x-www-form-urlencoded', 
       'charset' : 'utf-8',
      }
    })
    .then(response => {
      if(response['status'] == 200) {
        result = response.data.result
        context.commit('SET_COMPANY_DETAILS', {
          details: result,
        });
      }      
    })    
    .catch(e => {      
      var messageError = e.response ? e.response.data.message : e
      console.log(messageError);
    })
    context.commit('SET_API_STATE', {
      apiState: iliosState.LOADED
    });
    return result
  },

  async contact_us(context, { data }) {
    var result = null
    context.commit('SET_API_STATE', {
      apiState: iliosState.LOADING
    })
    data['contact_email'] = context.state.companyContactEmail;
    await axios.post(process.env.VUE_APP_BASE_URL + '/web/portal_lar/contact_us',
      {
        params: {
          payload: data,
          context : {
            "lang": "pt_BR",
            "tz" : Intl.DateTimeFormat().resolvedOptions().timeZone
          },
        },
      },
      {
        headers: {
          'Content-Type' : 'application/json',
          'charset' : 'utf-8',
        }
      }
    ).then(response => {
      if(response['status'] == 200) {
        result = response.data.data
    }
    }).catch(e => {
      var messageError = e.response ? e.response.data.message : e
      console.log(messageError);
    })
    context.commit('SET_API_STATE', {
      apiState: iliosState.LOADED
    });
    return result
  },

  reset(context) {
    context.commit('RESET');
  },
};

// Mutations
const mutations = {

  SET_COMPANY_DETAILS(state, { details }) {
    state.companyLogo = "data:image/jpeg;base64, " + details.logo;
    state.companyPhone = details.phone;
    state.companyWhatsApp = details.whatsapp;
    state.companyEmail = details.email;
    state.companyStreet = details.street;
    state.companyZip = details.zip;
    state.companyNumber = details.number;
    state.companyDistrict = details.district;
    state.companyContactEmail = details.contact_email;
    state.companyCity = details.cidade;
    state.companyState = details.state;
    state.companyName = details.name
    state.companyInstagram = details.instagram
    state.companyFacebook = details.facebook
    state.companyYoutube = details.youtube
    state.mainMenuColor = state.mainMenuColor ? state.mainMenuColor : details.mainMenuColor
    state.secondaryMenuColor = state.secondaryMenuColor ? state.secondaryMenuColor : details.secondaryMenuColor
    state.searchColor = state.searchColor ? state.searchColor : details.searchColor
  },

  SET_API_STATE(state, { apiState }) {
    state.apiState = apiState;
  },

  RESET(state) {
    const newState = initialState();
    Object.keys(newState).forEach((key) => {
      state[key] = newState[key];
    });
  },
};

export default {
  actions,
  state,
  getters,
  mutations,
  namespaced: true,
};